export const TYPE_SORT = {
  ALPHABETICALLY: "tri alphabétique",
  INCREASING: "tri croissant",
  DECREASING: "tri décroissant",
  INCREASING_P2: "tri croissant (période 2)",
  DECREASING_P2: "tri décroissant (période 2)",
  INCREASING_GAIN: "tri gain croissant",
  DECREASING_GAIN: "tri gain décroissant"
};

export const SOURCE = {
  BRAND: "byBrand",
  CATEGORY: "byCategory",
  FAMILY: "byFamily",
  SECTOR: "bySector",
  RETAILER: "byRetailer"
};
export const SOURCES_LIST = [
  { title: "MARQUES", key: SOURCE.BRAND, sourceLabel: ["brand_label"] },
  { title: "FAMILLES", key: SOURCE.FAMILY, sourceLabel: ["family_label"] },
  { title: "CATEGORIES", key: SOURCE.CATEGORY, sourceLabel: ["category_label"] },
  { title: "ENSEIGNES", key: SOURCE.RETAILER, sourceLabel: ["retailer_label"] },
  { title: "SECTEURS", key: SOURCE.SECTOR, sourceLabel: ["sector_label"] }
];



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Global/constants.js